import { whiteColor, grayColor } from 'assets/jss/material-dashboard-pro-react';

const changeNumberWrapperStyle = (theme) => ({
	changePasswordWrapper: (isNewDashBoardEnabled) => ({
		maxWidth: '100%',
		marginTop: isNewDashBoardEnabled ? 0 : '20px',
	}),
	contentWrapper: ({ isNewDashBoardEnabled }) => ({
		backgroundColor: whiteColor,
		padding: isNewDashBoardEnabled ? 0 : 32,
		borderRadius: 8,
		[theme.breakpoints.down('xs')]: {
			paddingLeft: 10,
			paddingRight: 10,
		},
	}),
	footer: ({ isNewDashBoardEnabled }) => ({
		display: 'flex',
		justifyContent: 'flex-end',
		padding: isNewDashBoardEnabled ? '16px' : '72px 0 0',
		borderTop: isNewDashBoardEnabled ? `1px solid ${grayColor[0]}` : 'none',
		'& button': {
			marginTop: 0,
			marginBottom: 0,
		},
		gap: isNewDashBoardEnabled ? '0.5rem' : 0,
	}),
});

export default changeNumberWrapperStyle;
